import { ColumnsType } from 'antd/lib/table';
import ButtonWithSpinner from 'components/common/ButtonWithSpinner';
import DefaultModal from 'components/common/DefaultModal';
import Table from 'components/Table';
import { MobileTableType } from 'components/Table/types';
import useReactiveQueryTable from 'hooks/useReactiveQueryTable';
import React, { useCallback } from 'react';
import { GET_TRANSACTIONS_MINIMAL } from 'services/graphql/queries/transactions.query';
import { GeneralFunction } from 'types/common';
import { ITransaction, TransactionStatusEnum } from 'types/transaction';

const CloneTransactionModal: React.FC<{
  visible?: boolean;
  onClose: GeneralFunction;
  onCloneClick: GeneralFunction;
}> = ({ onCloneClick, visible, onClose }) => {
  const cloneTransactionsColumn: ColumnsType<any> = [
    {
      title: 'Reference',
      dataIndex: 'reference',
      render: (text: string) => <span className='gx-font-weight-medium'>{text}</span>,
      ellipsis: true,
      width: '120px',
      // sorter: (a: ITransactionListTableProps, b: ITransactionListTableProps) => a.reference.localeCompare(b.reference),
    },
    {
      title: 'Description',
      dataIndex: 'description',
      ellipsis: true,
      // sorter: (a: ITransactionListTableProps, b: ITransactionListTableProps) => a.reference.localeCompare(b.reference),
    },
    {
      title: 'Transac. Type',
      dataIndex: 'transactionType',
      // sorter: (a: ITransactionListTableProps, b: ITransactionListTableProps) => a.reference.localeCompare(b.reference),
      ellipsis: true,
    },
    {
      title: '',
      dataIndex: 'transactionId',
      render: (transactionId: string) => (
        <div className='gx-text-center gx-w-100'>
          <ButtonWithSpinner
            onClick={() => {
              onCloneClick(transactionId);
            }}
            bgColorOnHover='transparent'
            borderColor='transparent'
            color='#038fdd'
            buttonType='text'
            width='auto'
            height='18px'>
            Clone
          </ButtonWithSpinner>
        </div>
      ),
      width: '80px',
    },
  ];

  const dataMapper = useCallback(
    (transaction: ITransaction) => ({
      key: transaction.id,
      reference: transaction.reference,
      description: transaction.description,
      transactionType: transaction.transactionType.name,
      transactionId: transaction.id,
    }),
    [],
  );

  const tableProps = useReactiveQueryTable({
    graphQLQuery: GET_TRANSACTIONS_MINIMAL,
    columns: cloneTransactionsColumn,
    dataMapper,
    mapQueryToVariables: () => ({
      status: TransactionStatusEnum.CANCELLED,
    }),
    queryProps: {
      skip: !visible,
    },
  });

  return (
    <DefaultModal
      props={{ title: 'Transactions', visible, onCancel: onClose, width: 600, bodyStyle: { maxWidth: '100%' } }}>
      <Table className='' {...tableProps} mobileDesignType={MobileTableType.RESPONSIVE_TABLE} widthThreshold={575} />
    </DefaultModal>
  );
};

export default React.memo(CloneTransactionModal);
